import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Box, Button, FlexGrid, StackView } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

import TankNumber from './components/tankNumber';
import TankName from './components/tankName';
import TankProduct from './components/tankProduct';
import TankType from './components/tankType';
import TankHeight from './components/tankHeight';
import TankCapacity from './components/tankCapacity';
import TankPortSize from './components/tankPortSize';

const AddDetailsFormFuelGauge = ({
  tankDetailsFarmAndRanch,
  setTankDetailsFarmAndRanch,
  sectionError
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    assigneeSRTModal: { addButton }
  } = localizedStrings;

  const initialState = {
    valueTankNumber: '',
    valueTankName: '',
    valueTankProduct: '',
    valueTankType: '',
    valueTankHeight: '',
    valueTankCapacity: '',
    valueTankPortSize: ''
  };

  const [dataField, setDataField] = useState(initialState);
  const [error, setError] = useState('');

  const validateForm = () =>
    [
      'valueTankNumber',
      'valueTankName',
      'valueTankProduct',
      'valueTankType',
      'valueTankHeight',
      'valueTankCapacity',
      'valueTankPortSize'
    ].every(field => dataField[field] !== '');

  const onAddInfo = () => {
    if (!validateForm()) {
      setError('Please enter all necessary information');
      return;
    }
    setTankDetailsFarmAndRanch({
      ...tankDetailsFarmAndRanch,
      fuelGauge: [...tankDetailsFarmAndRanch.fuelGauge, dataField]
    });
    setDataField(initialState);
    setError('');
  };

  useEffect(() => {
    setError(sectionError);
  }, [sectionError]);

  return (
    <StackView space={3}>
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col>
            <StackView space={3}>
              <TankNumber
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankName
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankProduct
                typeKey="fuelGauge"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['Gasoline', 'Diesel']}
                error={error}
              />
              <TankType
                typeKey="fuelGauge"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['Horizontal']}
                error={error}
              />
              <TankHeight
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankCapacity
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
              <TankPortSize
                typeKey="fuelGauge"
                dataField={dataField}
                setDataField={setDataField}
                fieldOptions={['2in NPT', 'Other']}
                error={error}
              />
            </StackView>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
      <Box style={{ padding: '1.5rem' }}>
        <Button onPress={onAddInfo}>{addButton}</Button>
      </Box>
    </StackView>
  );
};

AddDetailsFormFuelGauge.propTypes = {
  tankDetailsFarmAndRanch: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setTankDetailsFarmAndRanch: PropTypes.func.isRequired,
  sectionError: PropTypes.string.isRequired
};

export default AddDetailsFormFuelGauge;
